<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="textContent smallPadding max-w-1400">
          <div class="longText" style="white-space: pre-wrap" v-html="text"></div>
      </div>
    </div>
  </div>

</template>

<script>
import "./index.css";
import importedImg1 from "@/page/cre.inversionesmartinsas/components/img/privacy1.png";

export default {
  data(){
    return{
      importedImg1,
      text:`
Gracias por utilizar Inver Crédito (en adelante la “Aplicación”). Esta aplicación fue desarrollada por INVERSIONES FINAN MARTIN S.A.S. para brindarle información confiable sobre préstamos y servicios financieros.
Tomamos muy en serio sus derechos de privacidad y nos comprometemos a procesar sus datos personales de manera legal, transparente y de acuerdo con la Ley de Protección de Datos Personales de Colombia (Ley 1581 de 2012), el Decreto 1377 de 2013 y demás regulaciones pertinentes.
Esta Política de Privacidad le explicará cómo recopilamos, usamos, almacenamos, protegemos y, si es necesario, compartimos su información personal cuando utiliza esta Aplicación. Lea atentamente esta Política de privacidad antes de utilizar esta aplicación para asegurarse de que comprende completamente nuestras prácticas de procesamiento de datos.
Si tiene alguna pregunta o comentario sobre esta Política o desea ejercer sus derechos como titular de sus datos (como acceso, corrección, eliminación o retiro de autorización, etc.), puede contactarnos en cualquier momento por correo electrónico a office@inversionesmartinsas.com

La política incluye principalmente los siguientes contenidos:
Número de serie
título
1
Introducción a la función APP
2
Finalidad de la recopilación de información
3
Información clave recopilada
4
Cómo se almacena la información
5
Cómo se utiliza la información
6
Cookies
7
Seguridad de datos
8
Datos de usuario y eliminación (protección de datos de menores)
9
Planes de desarrollo futuros
10
Cambios en la Política de Privacidad
11
Contáctenos

Introducción a la función APP
Inver Crédito es una conveniente plataforma de préstamos en línea que puede ayudarle con sus necesidades financieras urgentes. No se requiere garantía ni pago por adelantado. Todo el proceso se completa en línea. Solo necesitas completar la solicitud en unos pocos pasos y el préstamo se desembolsará rápidamente.
Ya sea que necesite pagar gastos cotidianos, facturas o fondos de emergencia, Inver Crédito brinda apoyo crediticio confiable.
Detalles del préstamo
Monto máximo: COP 2.000.000
Plazo del préstamo: 91–180 días
Tasa de interés anual: sólo 21,9%/año (1,83%/mes).
Tarifas de servicio: Sin tarifas iniciales, sin cargos ocultos.

Ejemplo de préstamo
Si pides prestado 1.000.000 de pesos colombianos a 6 meses a una tasa de interés del 1,83% mensual,
• Interés mensual = COP 1.000.000 * 1,83% = COP 18.250
• Interés total = COP 1.000.000 * 1,83% * 6 = COP 109.500
• Monto total del pago = COP 1.000.000 + COP 1.000.000 * 1,83% * 6 = COP 1.109.500
• Pago mensual = COP 1.109.500 / 6 meses = COP 184.917

Finalidad de la recopilación de información
Prestación de servicios: Garantizar que se puedan proporcionar a los usuarios servicios financieros pertinentes, como solicitudes de préstamos, evaluaciones crediticias, etc.
Mejorar la experiencia del usuario: analizar los datos del usuario, optimizar los procesos y la experiencia del servicio y satisfacer las necesidades de los usuarios.
Gestión de riesgos: evaluar el riesgo crediticio de los prestatarios, reducir las tasas de incumplimiento y garantizar la seguridad de los préstamos.
Investigación de mercado: comprender las tendencias del mercado y las preferencias de los usuarios para orientar las estrategias de marketing y el desarrollo de productos.
Requisitos de cumplimiento: Cumplir con las leyes y regulaciones y garantizar que se cumplan los requisitos de cumplimiento pertinentes al prestar servicios financieros.
Atención al cliente: Brindar un servicio y soporte al cliente eficaz para resolver las preguntas e inquietudes de los usuarios.

Información clave recopilada
1. Información de identificación personal
Para garantizar la autenticidad y exactitud de la información proporcionada, recopilaremos su información personal básica, como número de teléfono móvil, nombre, número de identificación, información de la tarjeta bancaria, fecha de nacimiento, domicilio, información de la unidad de trabajo, etc. para verificar su identidad, verificar su solicitud y prevenir o detener el fraude.
2. Información de la imagen
Cuando deba cargar fotografías, Inver Crédito utilizará la función de selección de imágenes proporcionada por iOS, permitiéndole elegir únicamente las imágenes específicas que desee compartir. No accederemos a su galería completa ni a otras imágenes sin su consentimiento explícito. Las imágenes seleccionadas se enviarán de forma segura y cifrada a https://cre.inversionesmartinsas.com/. Garantizamos la protección y confidencialidad de su información.
3. Información de la lista de contactos
Con su autorización explícita, podremos permitirle seleccionar contactos específicos de su libreta de direcciones para designarlos como contactos de emergencia. Solo se accederá a los datos que usted seleccione voluntariamente (como nombre y número de contacto). Esta información será utilizada exclusivamente para validar su identidad, evaluar su solicitud de crédito y prevenir fraudes. Los datos serán almacenados de manera segura en https://cre.inversionesmartinsas.com/ y no serán compartidos con terceros.
4. Información del dispositivo
Para garantizar la compatibilidad del servicio y optimizar su experiencia, recopilaremos ciertos datos técnicos de su dispositivo, como el modelo del dispositivo, versión del sistema operativo, tipo de conexión de red y configuración regional. Estos datos se utilizarán exclusivamente para fines de funcionamiento técnico y se protegerán de acuerdo con los estándares de seguridad aplicables.
5. Información financiera
Para brindarle servicios financieros personalizados y protegerle contra riesgos de fraude, podremos solicitar y procesar, bajo su autorización, información financiera que usted decida compartir, como historial de transacciones o datos relacionados.
6. Información de geolocalización
Cuando utilice nuestros servicios, obtendremos información de su ubicación. Esto es para verificar su lugar de trabajo y dirección física para garantizar que se proporcionen los productos y servicios de préstamo más adecuados.
7. Derecho a filmar
Para identificar al usuario, cuando se requiera reconocimiento facial, podremos realizar reconocimiento biométrico cuando el usuario utilice la función de préstamo de productos, principalmente a través de permisos de cámara.
8. Información de la cuenta de redes sociales
Con su consentimiento, podremos recopilar información básica de sus cuentas sociales, como correo electrónico y número de teléfono, con fines de comunicación, marketing o elaboración de perfiles para mejorar nuestros servicios.
9. Calendario
Esta aplicación puede solicitar acceso a su calendario para brindarle la posibilidad de registrar fechas de pago, establecer recordatorios y administrar cronogramas relacionados con préstamos. Solo utilizamos este permiso con su autorización explícita y no recopilaremos, almacenaremos ni compartiremos la información de su calendario con ningún tercero. Puede administrar o revocar este permiso en cualquier momento si lo desea en la configuración de su dispositivo. Nos comprometemos a manejar su información personal adecuadamente y a respetar y proteger su privacidad. Para obtener más información o ejercer derechos pertinentes, contáctenos utilizando la información de contacto proporcionada en esta Política de privacidad.

Cómo se almacena la información
Inver Crédito almacena la información del usuario a través de una variedad de medidas de seguridad, incluyendo el cifrado de datos sensibles y el uso de bases de datos relacionales seguras y almacenamiento en la nube, para garantizar la confidencialidad y disponibilidad de la información. Además, la plataforma implementa estrictos controles de acceso para garantizar que solo el personal autorizado pueda acceder a los datos y realiza copias de seguridad periódicas para que los datos puedan restaurarse rápidamente cuando sea necesario. Todas las medidas de almacenamiento y procesamiento cumplen con las leyes y regulaciones pertinentes y están diseñadas para proteger la privacidad del usuario y la seguridad de los datos.

Cómo se utiliza la información recopilada
El propósito de utilizar la información del usuario es proporcionar servicios más personalizados, convenientes y seguros, optimizar la experiencia del usuario, mejorar la seguridad y cumplir con los requisitos legales. Al utilizar esta información de forma legal y transparente, no sólo podemos mejorar la calidad de nuestros servicios, sino también proteger la privacidad del usuario y mejorar su confianza.

Cookies  
Al utilizar los servicios de Inver Crédito, es posible que utilicemos cookies con el fin de mejorar su experiencia, analizar el rendimiento de la aplicación y mostrarle publicidad relevante. Las cookies son pequeños archivos de texto que se almacenan en su dispositivo. Usted puede gestionar o desactivar su uso a través de la configuración de su navegador. Solo utilizaremos cookies no esenciales con su consentimiento previo. Esta política puede actualizarse ocasionalmente, por lo que se recomienda revisarla periódicamente. Si tiene alguna duda o desea ejercer sus derechos relacionados con el uso de cookies, no dude en contactarnos.

Seguridad de datos
Inver Crédito protege los datos de los usuarios a través de una variedad de medidas de seguridad, incluyendo el cifrado de información sensible, el uso de servidores y bases de datos seguros para almacenar datos y estrictos controles de acceso para garantizar que sólo el personal autorizado tenga acceso. Además, la plataforma realiza controles de seguridad periódicos y detecciones de vulnerabilidades para protegerse contra posibles ataques cibernéticos, y cumple con las leyes y regulaciones pertinentes para garantizar que la privacidad de los usuarios esté completamente protegida. En conjunto, estas medidas crean un entorno seguro para garantizar que no se acceda ni se filtren los datos de los usuarios sin autorización.

Retención y eliminación de datos (protección de menores)
Inver Crédito no incentiva a menores de edad a utilizar esta aplicación. Durante el proceso de préstamo, adoptamos medidas como restricciones de edad para evitar que los menores utilicen la plataforma. Si la información personal de menores se guarda incorrectamente debido a una falla del sistema, los usuarios pueden eliminar la información de la cuenta relevante a través de la función de eliminación de datos. Si tiene alguna pregunta o problema, comuníquese con el servicio de atención al cliente y le ayudaremos.
Los usuarios pueden decidir conservar y eliminar su información personal en Inver Crédito, y respetamos y cooperamos con las solicitudes de eliminación de los usuarios. Ofrecemos los siguientes procedimientos de eliminación de datos:
Realizar una solicitud para eliminar la información de la cuenta en la aplicación: los usuarios pueden enviar una solicitud de eliminación en la aplicación y eliminaremos todos los datos relevantes de acuerdo con su solicitud.
Comuníquese con nosotros por correo electrónico y nuestro departamento de atención al cliente le ayudará a eliminar los datos. Correo electrónico oficial: office@inversionesmartinsas.com. Tenga en cuenta que una vez que se elimina la información de la cuenta, los datos no se pueden recuperar. Si desea volver a utilizar los servicios de Inver Crédito, deberá registrarse nuevamente. Gracias por su comprensión, estamos comprometidos a mejorar la calidad de nuestros productos y servicios.

Desarrollo y planificación futuros
En el futuro, Inver Crédito seguirá comprometido con ofrecer a los usuarios servicios financieros en Internet más seguros y transparentes. Al mismo tiempo, fortaleceremos la comunicación con los usuarios para asegurarnos de que comprendan nuestra política de privacidad y uso de datos.
Además, Inver Crédito participará activamente en la formulación de estándares de la industria y trabajará con reguladores, socios de la industria y usuarios para construir un ecosistema financiero más seguro. Creemos que sólo garantizando la privacidad y seguridad de la información de los usuarios podemos ganar la confianza de nuestros clientes y lograr el desarrollo sostenible de la empresa. En el futuro, seguiremos centrándonos en el usuario, promoveremos el desarrollo saludable de la industria de la tecnología financiera y trabajaremos con los usuarios para crear un futuro mejor.

Derechos y obligaciones del usuario
Al utilizar nuestras aplicaciones, los usuarios tienen derecho a la información, privacidad, trato justo, reclamaciones y transparencia para garantizar que comprenden el contenido del servicio y sus derechos. Al mismo tiempo, los usuarios están obligados a proporcionar información veraz, cumplir el acuerdo, reembolsar a tiempo, proteger la seguridad de la cuenta y cumplir con las leyes y regulaciones pertinentes.

Cambios a esta Política
Es posible que actualicemos nuestra política de privacidad de vez en cuando para adaptarnos mejor a los cambios en las leyes y regulaciones o para mejorar nuestros servicios. Cuando cambie la política de privacidad, se lo recordaremos mediante notificaciones en la aplicación u otros medios apropiados. La política de privacidad modificada entrará en vigor a partir de la fecha de publicación y se aplicará a toda la información recopilada. Si continúa utilizando nuestros servicios, usted está de acuerdo y acepta la política de privacidad actualizada. Le recomendamos que revise periódicamente la Política de Privacidad para conocer cualquier cambio.

Contáctenos
Si tiene alguna pregunta o comentario sobre nuestra política de privacidad o procesamiento de datos, puede contactarnos en cualquier momento utilizando la información de contacto a continuación y estaremos encantados de responder a sus preguntas.
Nombre de Empresa: INVERSIONES FINAN MARTIN SAS
Dirección de la empresa: CARRERA 10 52 13 SUR BOGOTA
Sitio web de la empresa: cre.inversionesmartinsas.com
Correo electrónico de la empresa: office@inversionesmartinsas.com
Horario de apertura: de lunes a domingo de 09:00 a 18:00
Gracias por su confianza, de todo corazón le brindaremos un servicio de calidad.`
    }
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style scoped>
.textContent{
  padding: 60px 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.smallPadding{
  padding: 10px 150px;
}

.title{
  color: #333333;
  font-family: "Thonburi";
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
}
.contentBox {
  display: flex;
  flex-direction: column;
  background-color: #FDFFFF;
  margin-bottom: 70px;
}
.flexBox {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}
.longText {
  font-size: 18px;
  color: #333333;
}
.bannerImgItem{
  width: 100%;
}
.imgItem {
  width: 100%;
}
.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}
</style>
